import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class TopicService {


  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }



constructor(private http: HttpClient) { }
getPlantsData(data: any): Observable<any[]> {
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetDepartments', data);
}
getMasterProject(data:any):Observable<any[]>{
  return this.http.post<any[]>(this.O3CoreApiUrl  +'Project/GetMasterProjects' ,data)
}
addTopic(data: any): Observable<any[]> {
  // return this.http.post<any[]>(this.kpiBaseUrl + 'addtopic', data );
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Topic/AddTopic', data );
}
deleteTopic(data: any): Observable<any> {
  // return this.http.post<any>(this.kpiBaseUrl + 'deletetopic', data );
  return this.http.post<any>(this.O3CoreApiUrl + 'Topic/DeleteTopic', data );
}
getMasterTopic(data:any):Observable<any[]>{
  //return this.http.post<any[]>(this.kpiBaseUrl +'mastertopic' ,data)
  return this.http.post<any[]>(this.O3CoreApiUrl +'Topic/GetMasterTopics' ,data)
}
GetOneMasterTopic(data: any): Observable<any> {
  // return this.http.post<any>(this.kpiBaseUrl + 'topic', data );
  return this.http.post<any>(this.O3CoreApiUrl + 'Topic/GetOneTopic', data );
}
updateTopic(data: any): Observable <any[]> {;
  // return this.http.put<any[]>(this.kpiBaseUrl + 'topic', data );
  return this.http.put<any[]>(this.O3CoreApiUrl + 'Topic/UpdateTopic', data );
}
}
